import React, { memo } from 'react'
import styles from './FormWrapper.module.scss'
import useWindowDimensions, { CurrentScreen } from '../../../hooks/use-window-dimensions'

export type TitleSectionProps = {
    title: string
    subtitle: string
    buttonTitle: string
}

type Props = {
    titleSection?: TitleSectionProps
    isNotValid?: boolean
    children: React.ReactNode
    onSaveAndContinue?: () => void
    onBack?: () => void
    backButton? :React.ReactNode;
    isSubmitted?: boolean;
}

const FormWrapper: React.FC<Props> = memo((props: Props) => {
    const { titleSection, children, onSaveAndContinue, onBack, backButton, isSubmitted, isNotValid } = props

    const currentScreen: CurrentScreen = useWindowDimensions();

    const isDisabled = (isSubmitted === null || isSubmitted === undefined) ? isNotValid : (isSubmitted && isNotValid);



    return titleSection ? (
        <>
            <div className={styles.headerContainer}>
                <div className={styles.headerSection}>
                    {
                        onBack && <button className={`standardButton ${styles.backButton}`} onClick={onBack}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.825 9L9.425 14.6L8 16L0 8L8 0L9.425 1.4L3.825 7H16V9H3.825Z" fill="#2E3336" />
                            </svg>
                        </button>
                    }
                    {backButton}
                    <div className={styles.header}>
                        <div className={styles.headerTitle}>
                            {titleSection?.title}
                        </div>
                        <div className={styles.headerSubtitle}>
                            {titleSection?.subtitle}
                        </div>
                    </div>
                </div>
                {
                    onSaveAndContinue && !currentScreen.isMobile && <button className={`standardButton ${styles.submitButton} ${isDisabled && styles.disableButton}`} disabled={isDisabled} onClick={onSaveAndContinue}>
                        {titleSection.buttonTitle} <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.94665 6.00047L0.873576 1.92737C0.735109 1.78892 0.664276 1.61489 0.661076 1.40527C0.657859 1.19568 0.728692 1.01844 0.873576 0.873575C1.01844 0.728692 1.19408 0.65625 1.40048 0.65625C1.60688 0.65625 1.78251 0.728692 1.92738 0.873575L6.4216 5.3678C6.5152 5.46138 6.58123 5.5601 6.61968 5.66395C6.65814 5.76778 6.67738 5.87996 6.67738 6.00047C6.67738 6.12099 6.65814 6.23317 6.61968 6.337C6.58123 6.44085 6.5152 6.53957 6.4216 6.63315L1.92738 11.1274C1.78893 11.2658 1.61489 11.3367 1.40527 11.3399C1.19568 11.3431 1.01844 11.2723 0.873576 11.1274C0.728692 10.9825 0.65625 10.8069 0.65625 10.6005C0.65625 10.3941 0.728692 10.2184 0.873576 10.0736L4.94665 6.00047Z" fill="#F68B1E" />
                        </svg>
                    </button>
                }
            </div>
            {children}
            {
                currentScreen.isMobile && <>
                    <div className={styles.separator} />
                    <div className={styles.footerContainer}>
                        {
                            onSaveAndContinue && <button className={`standardButton ${styles.submitButton} ${isDisabled && styles.disableButton}`} disabled={isDisabled} onClick={onSaveAndContinue}>
                                {titleSection.buttonTitle} <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.94665 6.00047L0.873576 1.92737C0.735109 1.78892 0.664276 1.61489 0.661076 1.40527C0.657859 1.19568 0.728692 1.01844 0.873576 0.873575C1.01844 0.728692 1.19408 0.65625 1.40048 0.65625C1.60688 0.65625 1.78251 0.728692 1.92738 0.873575L6.4216 5.3678C6.5152 5.46138 6.58123 5.5601 6.61968 5.66395C6.65814 5.76778 6.67738 5.87996 6.67738 6.00047C6.67738 6.12099 6.65814 6.23317 6.61968 6.337C6.58123 6.44085 6.5152 6.53957 6.4216 6.63315L1.92738 11.1274C1.78893 11.2658 1.61489 11.3367 1.40527 11.3399C1.19568 11.3431 1.01844 11.2723 0.873576 11.1274C0.728692 10.9825 0.65625 10.8069 0.65625 10.6005C0.65625 10.3941 0.728692 10.2184 0.873576 10.0736L4.94665 6.00047Z" fill="#F68B1E" />
                                </svg>
                            </button>
                        }
                    </div>
                </>
            }
        </>
    ) : null
})

export default FormWrapper